import { de } from './de';
import { en } from './en';
import { es } from './es';
import { fr } from './fr';
import { ja } from './ja';
import { nl } from './nl';
import { no } from './no';
import { pt_br } from './pt-br';
import { zh } from './zh';
export * from './types';
export var translations = {
    en: en,
    de: de,
    es: es,
    fr: fr,
    ja: ja,
    nl: nl,
    no: no,
    'pt-br': pt_br,
    zh: zh,
};
/**
 * Check if the locale is valid.
 */
export function checkIsValidLocale(locale) {
    return Object.prototype.hasOwnProperty.call(translations, locale);
}
